mutation SetMoneyPageIsEnabled($input: UrlSetIsEnabledInput!) {
    maUrlSetIsEnabled(input: $input) {
        url {
            id
            isEnabled
        }
    }
}
